import React, {useRef, useState, useEffect} from "react";
import {observer, inject} from "mobx-react";

import {Formik, Form, useField} from 'formik';
import * as Yup from 'yup';
import {TextInput, TextArea, CheckboxInput, TextLabel} from "@components/Form/FormFields";
import {SelectInput} from "../Form/FormFields";


@inject("store")
@observer
export default class CustomerAccount extends React.Component {


    constructor(props) {
        super(props);
        this.state = {
            customerAccountAdmin: null,
            customerAccount: null
        };
    }

    componentDidMount() {

        this.props.store.beriksson.customerAccountAdmin().then(res => {
            this.setState({customerAccountAdmin: res})
        })
    }

    render() {
        if (!this.props.store.navigation.getCustomerId()) {
            return <div>Error: No customer choosen</div>;
        }

        return (
            <div
            >


                <div className="row">
                    <div className="col-12">
                        {this.state.customerAccountAdmin && <AccountAdminForm
                            customerAccountAdmin={this.state.customerAccountAdmin}
                            berikssonStore={this.props.store.beriksson}
                            navigation={this.props.store.navigation}
                        />}
                    </div>
                </div>


            </div>);

    }
}


const AccountAdminForm = ({...props}) => {

    return (
        <Formik
            validateOnMount={true}
            enableReinitialize={true}
            initialValues={{
                cultureCode: props.cultureCode,
                nodeId: props.nodeId,
                customerType: props.customerAccountAdmin.CustomerType,
                customerNumber: props.customerAccountAdmin.CustomerNumber,
                customerName: props.customerAccountAdmin.CustomerName,
                organisationNumber: props.customerAccountAdmin.OrganisationNumber,
                countryCode: props.customerAccountAdmin.CountryCode,
                currencyCode: props.customerAccountAdmin.CurrencyCode,
                customerDiscountPercent: props.customerAccountAdmin.CustomerDiscountPercent,
                notes: props.customerAccountAdmin.Notes,
                priceGroupId: props.customerAccountAdmin.PriceGroupId

            }}
            validationSchema={Yup.object({

                customerName: Yup.string()
                    .required('Måste anges'),


                customerNumber: Yup.string()
                    .required('Måste anges'),

                priceGroupId: Yup.number().required("Måste anges").positive("Du måste välja prisgrupp").integer(),
                customerDiscountPercent: Yup.number().required("Måste anges").min(0,"Får minst vara: 0").max(100, "Får max vara: 100").integer(),
            })}
            //onSubmit={onSubmitWithReCAPTCHA}
            onSubmit={(values, {setSubmitting}) => {
                //alert(JSON.stringify(values, null, 2));
                props.berikssonStore.customerAccountAdminUpdate(values).then(res => {
                        props.navigation.toast("Uppgifterna sparades");
                        setSubmitting(false);
                        props.navigation.GetMyPages(props.navigation.SiteId, "CustomerAdmin.onSubmit");
                        props.navigation.GetNavigation(props.navigation.SiteId, "CustomerAdmin.onSubmit");
                    },
                    errorResponse => {
                        let errorMessage = "Ett fel uppstod:";
                        errorResponse.errors.forEach(x=> errorMessage += "\r\n- " + x)
                        props.navigation.toastError(errorMessage);
                        setSubmitting(false);
                    }
                )
            }}

        >
            {({values, setSubmitting, isSubmitting, handleBlur, setFieldValue, isValid}) => {
                //  noValidate
                return <Form>
                    <h4 className="text-normal pt-4">Kundadministration</h4>
                    <hr className="mb-3"/>
                    <div className={"row"}>
                        <div className={"col-sm-4"}>
                            <SelectInput
                                label="Kundtyp"
                                name="customerType"
                            >
                                {props.customerAccountAdmin.CustomerTypes.map(ct => {
                                    return (<option value={ct} key={ct}>{ct}</option>)
                                })}

                            </SelectInput>
                        </div>
                    </div>
                    <div className={"row"}>
                        <div className={"col-sm-4"}>
                            <TextInput
                                label="Företagsnamn"
                                name="customerName"
                                type="text"
                            /></div>
                        <div className={"col-sm-4"}>
                            <TextInput
                                label="Kundnummer"
                                name="customerNumber"
                                type="text"

                            /></div>

                        <div className={"col-sm-4 "}>
                            <TextInput
                                label="Organisationsnummer"
                                name="organisationNumber"
                                type="text"
                            />
                        </div>
                    </div>

                    <div className={"row"}>
                        <div className={"col-sm-4"}>

                            <TextLabel

                                label="Landskod"
                                name="countryCode"
                                type="text"

                            /></div>
                        <div className={"col-sm-4"}>
                            <SelectInput
                                label={"Prisgrupp (" + props.customerAccountAdmin.CurrencyCode + ")"}
                                name="priceGroupId"
                            >
                                {props.customerAccountAdmin.PriceGroups.map(pg => {
                                    return (<option value={pg.PriceGroupId} key={pg.PriceGroupId}>{pg.Name}</option>)
                                })}

                            </SelectInput>


                        </div>
                        <div className={"col-sm-4 "}>
                            <TextInput
                                label="Kundrabatt (%)"
                                name="customerDiscountPercent"
                                type="number"
                            />
                            <small className="form-text text-muted pl-0 mb-sm-n5">Ändring av kundrabatt kan ta upp till 5 minuter medan navigation och produkter uppdateras.</small>
                        </div>
                    </div>

                    <div className={"row"}>
                        <div className={"col-sm-8"}>

                            <TextArea
                                label="Anteckningar"
                                name="notes"
                                type="text"

                            /></div>

                    </div>


                    <button className="btn btn-success"
                            type="submit"
                            disabled={isSubmitting || !isValid}>Spara
                    </button>

                </Form>
            }
            }
        </Formik>
    );
};
